export default __webpack_public_path__ + "static/media/page9Image2_en.01636364.jpg";